export default __webpack_public_path__ + "static/media/1.11cb14d2.jpg";